export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-50 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-xl font-heading text-primary-500 mb-4">虫虫漫画</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              虫虫漫画大全汇集全集免费漫画，好看的韩漫日漫国漫分类推荐，支持下拉式在线阅读，追更收藏尽在虫虫漫画平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">首页</a>
              <a href="#cards" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">精选推荐</a>
              <a href="#ranking" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">热门排行</a>
              <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">漫画分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#topics" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">韩漫</a>
              <a href="#topics" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">日漫</a>
              <a href="#topics" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">国漫</a>
              <a href="#index" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer no-underline">全部分类</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500">优质漫画平台共建生态</p>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 虫虫漫画 - 虫虫漫画大全. 本站内容仅供阅读交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">关于我们</a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">联系我们</a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}